import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { RiMailSendLine } from "react-icons/ri";
import { TiArrowRight } from "react-icons/ti";
import { Link } from "react-router-dom";
import SendMailer from "./SendMailer";

function ContactMe() {
  return (
    <div className="pt-[80px]" id="contact">
      <div className="text-center">
        <h1 className="lg:text-4xl text-3xl font-semibold">Contact Me</h1>
        <p className="lg:text-xl">Get In Touch</p>
      </div>

      <div className="my-[60px] mx-auto grid gap-10 sm:grid-cols-2
      md:w-9/12">
        <div>
          <h1 className="lg:text-2xl text-xl text-center font-semibold">
            Talk to Me
          </h1>

          <div className="mt-[25px] space-y-3 ">
            <Link
              to={"mailto:shreyashKumar9806@gmail.com"}
              className="border py-2 flex flex-col items-center bg-white rounded-md"
            >
              <span>
                <RiMailSendLine fontSize={"1.5rem"} />
              </span>
              <h2 className="font-medium text-[0.9rem]">Email</h2>
              <div>shreyashKumar9806@gmail.com</div>
              <button
                className="flex items-center mt-2 transition-all duration-300
            hover:text-black text-[0.9rem]"
              >
                Write me
                <TiArrowRight fontSize={"1.3rem"} />
              </button>
            </Link>

            <Link
              to={"https://wa.me/7017462302" }
              target="_blank"
              className="border py-2 flex flex-col items-center bg-white rounded-md"
            >
              <span>
                <FaWhatsapp fontSize={"1.5rem"} />
              </span>
              <h2 className="font-medium text-[0.9rem]">WhatsApp</h2>
              <div>+91 7017462302</div>
              <button
                className="flex items-center mt-2 transition-all duration-300
            hover:text-black text-[0.9rem]"
              >
                Write me
                <TiArrowRight fontSize={"1.3rem"} />
              </button>
            </Link>
          </div>
        </div>

        <SendMailer />
      </div>
    </div>
  );
}

export default ContactMe;
